import React from 'react';

import PackagesModal from './component';

export default React.memo(PackagesModal);
